import Table from '@/shared/components/Table';
import Art123GenerateAgreementForm from './Art123GenerateAgreementForm';
import Art123GenerateResultModal from './Art123GenerateResultModal';
import { useArt123 } from '../hooks/useArt123';

export default function Art123() {
    const {
        t,
        view,
        tableData,
        loading,
        error,
        searchType,
        setSearchType,
        searchQuery,
        setSearchQuery,
        searchOptions,
        selectedCompany,
        setSelectedCompany,
        companyOptions,
        modalState,
        handleOpenModal,
        handleCloseModal,
        fetchData,
        handleSearch,
        handleGenerateAgreement,
        generateResult,
        handleCloseGenerateResult,
    } = useArt123();

    const firstColumns = [
        { key: 'idn', label: t('staff.art123.table.headers.idn') },
        { key: 'name', label: t('staff.art123.table.headers.name') },
        { key: 'middleName', label: t('staff.art123.table.headers.middleName') },
        { key: 'surname', label: t('staff.art123.table.headers.surname') },
        { key: 'businessNumber', label: t('staff.art123.table.headers.businessNumber') },
        { key: 'typeOfContract', label: t('staff.art123.table.headers.typeOfContract') },
        { key: 'numberOfContract', label: t('staff.art123.table.headers.numberOfContract') },
        { key: 'dateOfContract', label: t('staff.art123.table.headers.dateOfContract') },
        { key: 'terminatedDate', label: t('staff.art123.table.headers.terminatedDate') },
    ];

    const secondColumns = [
        { key: 'enforcedFrom', label: t('staff.art123.table.headers.enforcedFrom') },
        { key: 'idn', label: t('staff.art123.table.headers.idn') },
        { key: 'name', label: t('staff.art123.table.headers.name') },
        { key: 'middleName', label: t('staff.art123.table.headers.middleName') },
        { key: 'surname', label: t('staff.art123.table.headers.surname') },
        { key: 'businessNumber', label: t('staff.art123.table.headers.businessNumber') },
        { key: 'status', label: t('staff.art123.table.headers.status') },
        { key: 'basis', label: t('staff.art123.table.headers.basis') },
    ];

    const activeColumns = view === 'employer' ? firstColumns : secondColumns;

    const actionButtons = (
        <>
            <button
                type="button"
                className={`btn ${view === 'employer' ? 'form-btn btn-red' : 'btn-primary'}`}
                onClick={() => fetchData('employer')}
                disabled={loading && view !== 'employer'}
            >
                {t('staff.art123.table.headers.changeEmployer')}
            </button>
            <button
                type="button"
                className={`btn ${view === 'contracts' ? 'form-btn btn-red' : 'btn-primary'}`}
                onClick={() => fetchData('contracts')}
                disabled={loading && view !== 'contracts'}
            >
                {t('staff.art123.table.headers.generatedAgreements')}
            </button>
            <button
                type="button"
                className="form-btn btn-green"
                onClick={() => handleOpenModal('generate')}
            >
                {t('staff.art123.table.headers.generateAgreement')}
            </button>
        </>
    );

    return (
        <>
            <Table
                title={t('staff.art123.title')}
                columns={activeColumns}
                data={tableData}
                loading={loading}
                error={error}
                actionButtons={actionButtons}
                searchOptions={searchOptions}
                searchQuery={searchQuery}
                searchType={searchType}
                setSearchQuery={setSearchQuery}
                setSearchType={setSearchType}
                getData={fetchData}
                handleSearchClick={handleSearch}
                showCompanySelect={true}
                companySelectLabel={t('staff.art123.search.previousEmployer')}
                companyOptions={companyOptions}
                selectedCompany={selectedCompany}
                setSelectedCompany={setSelectedCompany}
                showPreviousPage={false}
                showPageSizeSelector={false}
                showPagination={false}
            />

            {modalState.visible && modalState.type === 'generate' && (
                <Art123GenerateAgreementForm
                    onClose={handleCloseModal}
                    onConfirm={handleGenerateAgreement}
                />
            )}

            {generateResult && (
                <Art123GenerateResultModal
                    result={generateResult}
                    onClose={handleCloseGenerateResult}
                />
            )}
        </>
    );
}
